import QueryKeyFactory from "../../../api/hooks/utils/queryKeyFactory";

export const addressKeys = new QueryKeyFactory('address')
